import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, inject } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  loader = false;
  constructor(public sharedDataService:  SharedDataService ) { }

  ngOnInit(): void {
    this.sharedDataService.getLoaderTrigger().subscribe(r => {
      this.loader = r;
      console.log(this.loader, 'laoder');
    });
  }


  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
}
